import { Capacitor, registerPlugin } from "@capacitor/core";
import { useFetch } from "~vue/api";

export interface EntraMobileRequest {
    challenge: string;
    tenant_id: string;
    scope: string;
    exchange_url: string;
    complete_url: string;
}

interface EntraMobilePlugin {
    signIn(options: EntraMobileRequest): Promise<{ code: string }>;
}

const plugin = registerPlugin<EntraMobilePlugin>("EntraMobile");
export class EntraMobileUnavailable extends Error {}

export async function enrollWithIntune(request: EntraMobileRequest): Promise<string> {
    if (!Capacitor.isNativePlatform() || !Capacitor.isPluginAvailable("EntraMobile")) {
        throw new EntraMobileUnavailable();
    }
    let code: string;
    try {
        ({ code } = await plugin.signIn(request));
    } catch (error) {
        if (error && typeof error === "object" && "code" in error && ["UNIMPLEMENTED", "UNAVAILABLE", "REGISTRATION_MISSING"].includes(String(error.code))) {
            throw new EntraMobileUnavailable();
        }
        throw new Error("ENTRA_SIGN_IN_FAILED");
    }
    // Only this session-bound, single-use code crosses the bridge, never Microsoft tokens.
    const { data, error } = await useFetch(request.complete_url).post({ code }).json<{ redirect_url: string }>();
    if (error.value || !data.value?.redirect_url) {
        throw new Error("ENTRA_ENROLLMENT_FAILED");
    }
    return data.value.redirect_url;
}
